export default theme => ({
  popover: {
    width: '220px',
    '& .hoi-poi-popover-inner': {
      padding: '10px',
      height: '175px'
    }
  },
  singleImagePopover: {
    '& .hoi-poi-popover-inner': {
      height: '95px',
      '& $carouselImage > img': {
        maxHeight: '95px'
      }
    }
  },
  carouselImage: {
    textAlign: 'center',
    outline: 'none',
    '& > img': {
      maxWidth: '150px',
      maxHeight: '150px',
      verticalAlign: 'middle'
    }
  },
  textarea: {
    '& textarea': {
      overflow: 'hidden'
    }
  },
  overlay: {
    zIndex: 1601
  }
});